import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "../../../utils/appToast";
import "./otp.css";
import verifylogo from "../../../Images/Succes-email.png";
import api from "../../chat/api";

const OtpPage = ({ closeModal, setEmailAccountVerified }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [email, setEmail] = useState("");
  const [verify, setVerify] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const inputRefs = useRef([]);

  const showError = (message) => {
    setErrorMessage(message);
    setShowErrorPopup(true);
  };

  useEffect(() => {
    const emailFromState = location.state?.email;
    if (emailFromState) {
      setEmail(emailFromState);
    } else {
      navigate("/signup");
    }

    inputRefs.current[0]?.focus();

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [location.state, navigate]);

  useEffect(() => {
    const isOtpRequired = localStorage.getItem("otp_verification_required");
    if (!isOtpRequired) {
      navigate("/signup", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    if (verify) {
      navigate("/payment");
    }
  }, [verify, navigate]);

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) inputRefs.current[index + 1]?.focus();
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("Text").slice(0, 6).split("");
    if (pasted.every((char) => /^\d$/.test(char))) {
      const newOtp = new Array(6).fill("");
      pasted.forEach((char, i) => {
        newOtp[i] = char;
        if (inputRefs.current[i]) inputRefs.current[i].value = char;
      });
      setOtp(newOtp);
      inputRefs.current[Math.min(pasted.length, 6) - 1]?.focus();
    }
  };

  const handleVerify = async () => {
    const otpCode = otp.join("");
    try {
      const response = await api.post("api/v1/accounts/verify/", {
        email,
        otp: otpCode,
      });

      if (response.data.message === "Account verified successfully.") {
        toast.success("Account verified successfully!", { autoClose: 1000 });
        localStorage.setItem("token", response.data.token);
        localStorage.removeItem("otp_verification_required");
        navigate("/payment");
      } else if (response.data.data === "Wrong OTP") {
        showError("Wrong OTP. Please check and try again.");
      } else if (response.data.data === "Invalid email") {
        showError("Invalid Email. Please go back and re-enter.");
      } else {
        showError("Verification failed. Please try again.");
      }
    } catch (error) {
      console.error("Verification error:", error);
      if (error.response?.data?.data?.otp?.length > 0) {
        showError(error.response.data.data.otp[0]);
      } else if (error.response?.data?.message) {
        showError(error.response.data.message);
      } else {
        showError("Something went wrong. Please try again.");
      }
    }
  };

  const handleResendOTP = async () => {
    if (isResendDisabled) return;
    try {
      const response = await api.post("api/v1/accounts/resend-otp/");
      if (response.data.message === "New OTP sent to your email address.") {
        toast.success("OTP resent successfully", { autoClose: 1000 });
        setOtp(new Array(6).fill(""));
        inputRefs.current.forEach((input) => (input.value = ""));
        inputRefs.current[0]?.focus();
        setTimeLeft(30);
        setIsResendDisabled(true);
      } else {
        toast.info(response.data.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error while resending OTP:", error);
    }
  };

  const handleGoBack = () => {
    navigate("/signup");
  };

  return (
    <div className="otp-fullContainer relative">
      <div className="w-[164.713px] h-[30px] flex-shrink-0 absolute top-[61px] left-[661px] bg-#FFF">
        <img src="/docusensasign.svg" alt="docuSensa logo" className="w-full h-full" />
      </div>
      <div className="absolute main-otppage z-50">
        <div className="flex items-center justify-center">
          {verify ? (
            <div className="otpverify-container relative bg-white h-auto text-center">
              <div className="flex justify-center items-center mt-8">
                <img src={verifylogo} alt="email verify logo" className="w-[245px] h-[98px]" />
              </div>
              <div className="mt-3">
                <h2 className="verify-topHeading">Your E-mail has been Verified</h2>
                <p className="verify-subHeading">Your email has been successfully verified.</p>
              </div>
              <div>
                <button onClick={() => navigate("/payment")} className="close-verifybtn text-white text-center mt-9">
                  Close
                </button>
              </div>
            </div>
          ) : (
            <div className="otp-container relative h-auto text-center">
              <div className="text-left">
                <img src="/otp-pageIcon.svg" alt="" className="otp-PageIcon" />
                <h1 className="top-heading">Verify Email </h1>
                <div className="sub-heading w-[415px] mt-4">
                  <p>
                    Please enter the 6 digit Verification code that has been sent to{" "}
                    {email.replace(/(^.{2})(.*)(@.*)/, "$1******$3")}
                  </p>
                </div>
              </div>

              <div className="otp-box-cont flex flex-row gap-3 items-center">
                {otp.map((value, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    className="otp-box"
                    type="text"
                    maxLength="1"
                    value={value}
                    onChange={(e) => handleInputChange(e, index)}
                    onKeyDown={(e) => handleBackspace(e, index)}
                    onPaste={handlePaste}
                  />
                ))}
              </div>

              <div>
                {isResendDisabled ? (
                  <button disabled className="resend-btn flex justify-end mt-[15px] resent-btn">
                    Resend OTP in {Math.floor(timeLeft / 60).toString().padStart(2, "0")}:
                    {(timeLeft % 60).toString().padStart(2, "0")}
                  </button>
                ) : (
                  <button onClick={handleResendOTP} className="otp-resend">
                    <span className="otp-text">Did not receive OTP?</span>
                    <span className="otp-resend-text"> Resend OTP</span>
                  </button>
                )}
              </div>

              <div className="flex justify-start ml-8 mt-4">
                <button onClick={handleVerify} className="verify-btn text-center">
                  Verify E-mail
                </button>
              </div>
            </div>
          )}
        </div>
        <p className="wrong-email">
          Wrong Email id?{" "}
          <button onClick={handleGoBack} className="go-back-button">
            <span>Go back</span>
          </button>
        </p>
      </div>

      {showErrorPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="design-for-alerts">
            <img src="/alert-icon.svg" alt="Alert logo" className="alert-icon-design" />
            <h2 className="alerts-heading mt-2">Can’t Complete Request</h2>
            <p className="alerts-heading-response">{errorMessage}</p>
            <button onClick={() => setShowErrorPopup(false)} className="alerts-button-okay">
              Okay
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OtpPage;
